import React from 'react';
import {
  Form,
  FormInstance,
  SubmitButton,
  TextInput,
  Checkbox
} from 'blueprint-form';
import FormSelectApp from '../select/form/apps';
import { PMTemplateTagsInput } from './templates';
import { Col, Row } from '../../../grid';

const SELECT_ALL_LABEL = '-- All --';

interface PushMessageFilterProps {
  filter: (
    tag: string,
    app: string,
    query: string,
    fetchOnlyChatTemplates: boolean
  ) => void;
  filterBtnMargin?: string;
  showChatTemplateFilter?: boolean;
}

interface PushMessageFilterData {
  tag?: string;
  app?: string;
  query?: string;
  fetchOnlyChatTemplates?: boolean;
}

const PushMessageFilter = ({
  filter,
  filterBtnMargin = '30px',
  showChatTemplateFilter = true
}: PushMessageFilterProps): JSX.Element => {
  const form = new FormInstance<PushMessageFilterData>({
    tag: '',
    app: '',
    query: '',
    fetchOnlyChatTemplates: false
  });
  const onSubmit = (_data: PushMessageFilterData) => {
    filter(_data.tag, _data.app, _data.query, _data.fetchOnlyChatTemplates);
  };
  return (
    <Form form={form} onSubmit={onSubmit}>
      <Row>
        <Col>
          <TextInput
            label="Filter By Keyword"
            placeholder="e.g., food"
            name="query"
            fill
          />
        </Col>
        <Col>
          <PMTemplateTagsInput
            label="Filter By Tags"
            name="tag"
            placeholder="Select one or more tags"
            allowCreate={false}
            fill
          />
        </Col>
        <Col>
          <FormSelectApp
            label="Filter By Program"
            selectAllLabel={SELECT_ALL_LABEL}
            name="app"
            fill
          />
        </Col>
        {showChatTemplateFilter ? (
          <Col>
            <div style={{ marginTop: '24px' }}>
              <Checkbox label="Chat Only" name="fetchOnlyChatTemplates" />
            </div>
          </Col>
        ) : null}
        <Col>
          <SubmitButton
            intent="success"
            style={{
              marginTop: filterBtnMargin
            }}
            fill
          >
            Filter
          </SubmitButton>
        </Col>
      </Row>
    </Form>
  );
};

export default PushMessageFilter;
